<template>
  <div class="sidebar-menu-tree">
    <sidebar-menu-option :elementId="elementId"
                         :current="current"
                         :clickFunction="clickFunction"
                         :icon="icon"
                         :label="label"
                         :notificationCount="notificationCount"
                         :hasChildren="hasViewableChildren"
                         :aria-haspopup="hasViewableChildren"
                         :aria-expanded="ariaExpanded"
                         @toggle="toggleSelection">
    </sidebar-menu-option>

    <b-collapse v-if="hasViewableChildren"
                :id="`${elementId}Collapse`"
                class="nested-item"
                v-model="expandCollapse">
      <sidebar-menu-option v-for="childOption in viewableChildren"
                           :elementId="childOption.elementId"
                           :current="childOption.current"
                           :clickFunction="childOption.function"
                           :icon="childOption.icon"
                           :label="childOption.label"
                           :key="childOption.elementId"
                           :notificationCount="childOption.notificationCount">
      </sidebar-menu-option>
    </b-collapse>
  </div>
</template>

<script>
import SidebarMenuOption from './SidebarMenuOption.vue'

export default {
  name: 'sidebar-menu-tree',

  components: {
    SidebarMenuOption
  },

  props: {
    elementId: String,
    current: Boolean,
    clickFunction: Function,
    label: String,
    icon: String,
    children: Array,
    notificationCount: Number
  },

  data () {
    return {
      expandCollapse: false
    }
  },

  computed: {
    ariaExpanded () {
      return !this.hasViewableChildren ? undefined : this.expandCollapse
    },

    viewableChildren () {
      return Array.isArray(this.children) ? this.children.filter(child => child.display) : []
    },

    hasViewableChildren () {
      return this.viewableChildren.length > 0
    }
  },

  methods: {
    toggleSelection () {
      if (this.hasViewableChildren) {
        this.expandCollapse = !this.expandCollapse
      }
    }
  }
}
</script>

<style scoped>
.nested-item {
  padding-left: 19%;
}
</style>
